import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useToast } from '@/hooks/use-toast';
import { deleteAllUsersExcept } from '@/utils/adminUserDeletion';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { ListingImageGenerator } from '@/components/admin/ListingImageGenerator';

export default function AdminUserCleanup() {
  const [keepEmail, setKeepEmail] = useState('kieron@dowdgroup.com.au');
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const handleDeleteUsers = async () => {
    if (!keepEmail) {
      toast({
        title: 'Error',
        description: 'Please enter an email to keep',
        variant: 'destructive',
      });
      return;
    }

    // Additional confirmation for this dangerous operation
    const confirmMessage = `⚠️ CRITICAL ACTION ⚠️\n\nThis will permanently delete ALL users except ${keepEmail}.\n\nThis action CANNOT be undone.\n\nType "DELETE ALL USERS" to confirm:`;
    const userConfirmation = window.prompt(confirmMessage);
    
    if (userConfirmation !== 'DELETE ALL USERS') {
      toast({
        title: 'Cancelled',
        description: 'User deletion cancelled',
      });
      return;
    }

    setIsLoading(true);
    try {
      const result = await deleteAllUsersExcept(keepEmail);
      
      toast({
        title: 'Success',
        description: result.message,
      });
      
      console.log('Deletion results:', result.results);
    } catch (error: any) {
      toast({
        title: 'Error',
        description: error.message || 'Failed to delete users',
        variant: 'destructive',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto space-y-6">
          <ListingImageGenerator />
          
          <Card>
            <CardHeader>
              <CardTitle>Admin User Cleanup</CardTitle>
              <CardDescription>
                Delete all registered users except the one specified below
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="keepEmail">Email to Keep</Label>
                <Input
                  id="keepEmail"
                  type="email"
                  value={keepEmail}
                  onChange={(e) => setKeepEmail(e.target.value)}
                  placeholder="user@example.com"
                />
              </div>
              <Button
                onClick={handleDeleteUsers}
                disabled={isLoading}
                className="w-full"
                variant="destructive"
              >
                {isLoading ? 'Deleting Users...' : 'Delete All Other Users'}
              </Button>
            </CardContent>
          </Card>
        </div>
      </main>
      <Footer />
    </div>
  );
}